import React from 'react';
import { CtaButton } from './CtaButton';
import { FrameworkFlow } from './FrameworkFlow';
import { SectionEyebrow } from './SectionEyebrow';
import { heroHighlights, IMAGES } from '../data/coachSystem';
export function Hero() {
  return <header className="border-b border-char-line bg-ink" data-id="element-59" data-mp="9lbfcytwl7cj">
      <div className="mx-auto w-full max-w-[42rem] px-4 pb-9 pt-7 text-center sm:px-6 sm:pb-12 sm:pt-10 lg:max-w-3xl lg:pb-16 lg:pt-14" data-id="element-60" data-mp="4m8l89fgoljc">
        <SectionEyebrow label="Basketball Coach System™" data-id="element-61" data-mp="128yz6bncnty4" />

        <h1 className="mt-4 font-display text-[2.15rem] font-semibold uppercase leading-[1.05] tracking-tight text-ivory sm:text-[2.9rem] lg:text-[3.3rem]" data-id="element-62" data-mp="x9usbrnwe8ay">
          The Complete Coaching System for Basketball Coaches
        </h1>

        <p className="mx-auto mt-3.5 max-w-[36rem] text-[0.98rem] leading-relaxed text-ivory-muted sm:text-[1.05rem]" data-id="element-63" data-mp="nbop96qcuw4i">
          Save hours of planning, run better practices, and coach with
          confidence — without building every practice, drill and game plan
          from scratch.
        </p>

        <img src={IMAGES.bundle} alt="The complete Basketball Coach System™ bundle: six professional coaching volumes and five bonuses shown beside the system box." className="mx-auto -mb-1 mt-5 w-full max-w-[28rem] sm:mt-7 sm:max-w-[32rem] lg:max-w-[36rem]" width={1400} height={1100} data-id="element-64" data-mp="3j923fiwkdgsw" />

        <p className="mt-5 font-display text-[1.05rem] font-semibold uppercase tracking-[0.04em] text-ivory sm:text-[1.2rem]" data-id="element-65" data-mp="30ib0p0730onh">
          6 Professional Volumes{' '}
          <span className="text-orange" aria-hidden="true" data-id="element-66" data-mp="35a2jupnwrs3l">
            +
          </span>{' '}
          5 Practical Bonuses
        </p>

        <ul className="mx-auto mt-4 grid max-w-[30rem] grid-cols-1 justify-items-center gap-x-6 gap-y-1.5 sm:grid-cols-2" data-id="element-67" data-mp="2viojkfo4uo9e">
          {heroHighlights.map(item => <li key={item} className="flex items-center justify-center gap-2 text-center text-[0.88rem] leading-snug text-ivory-soft sm:text-[0.92rem]" data-id="element-68" data-mp="2hl9r122l20d7">
              <span className="h-1 w-1 shrink-0 rounded-full bg-orange" aria-hidden="true" data-id="element-69" data-mp="s44ghj521dfs" />
              {item}
            </li>)}
        </ul>

        <FrameworkFlow className="mt-6" data-id="element-70" data-mp="ia5jsznr2lv8" />

        <CtaButton label="Get the complete system" size="lg" className="mx-auto mt-4 sm:w-auto" data-id="element-71" data-mp="ddnenyoiclid" />
        <p className="mt-2.5 text-[0.8rem] text-ivory-dim" data-id="element-72" data-mp="1b0du65c1o1z9">
          Instant digital access • No subscription
        </p>
      </div>
    </header>;
}